module.exports = __webpack_public_path__ + "img/clipboard_2.49742a65.png";